/*
  NordiskPuls NO - farveskift paa gavelinjen i kurven
  =================================================================
  Markup'en staar i snippets/np-gave-farver.liquid. Her er kun adfaerden.

  Lytteren er delegeret fra document og ikke hangt paa knapperne. Hele
  .drawer__inner erstattes med innerHTML ved hver kurv-opdatering, saa
  alt hvad der var hangt direkte paa et element derinde, ville vaere vaek
  efter foerste skift.

  FIRE TING DER HVER ISAER HAR VAERET EN FEJL I DK:

  1. SKAERMEN OPDATERES FOERST. Shopifys kurv-endpoints tager 0,5-1,8 sek
     hver, og et farveskift er to kald. Venter vi paa serveren, gaar der
     to-tre sekunder foer ringen flytter sig, og kunden klikker igen.

  2. KLIKKENE SAMLES. Skifter kunden groen -> lilla -> blaa, er lilla
     ligegyldig. Uden samling blev hvert klik til fjern+tilfoej, og fire
     klik gav otte kald og fem sekunders efterslaeb hvor kurven blev
     tegnet om under fingeren paa kunden. Nu ventes 420 ms efter sidste
     klik. Ender hun samme sted som hun startede, sendes ingenting.

  3. DER FJERNES FOER DER TILFOEJES. Shopify hasher line keys om ved hver
     aendring OG indsaetter nye varer FORREST. Noeglen fra markup'et er
     derfor ugyldig efter en add. Ved at fjerne foerst kan vi bruge den.

  4. MOTOREN LAASES UDE IMENS. Mellem fjern og tilfoej findes gaven ikke i
     kurven. Ser np-gavemotor.js det oejeblik, lagger den en gave nummer
     to i. window.isProcessingGift er den samme vagt som nesestrips-
     logikken bruger, saa begge holder sig vaek.
*/
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var SAMLETID = 420;   // ms efter sidste klik foer der sendes

  var ventende = null;
  var ur = null;

  function post(path, body) {
    return fetch(ROOT + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok) throw new Error(d.description || d.message || 'Kurv-fejl');
        return d;
      });
    });
  }

  function tegnKurvOm(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var inder = document.querySelector('.drawer__inner');
    var nyInder = doc.querySelector('.drawer__inner');
    if (inder && nyInder) inder.innerHTML = nyInder.innerHTML;
    ['cart-drawer', 'cart-drawer-items'].forEach(function (sel) {
      var nu = document.querySelector(sel), ny = doc.querySelector(sel);
      if (nu && ny) nu.classList.toggle('is-empty', ny.classList.contains('is-empty'));
    });
  }

  function gentegn(data) {
    if (data && data.sections && data.sections['cart-drawer']) {
      tegnKurvOm(data.sections['cart-drawer']);
      return Promise.resolve();
    }
    return fetch(ROOT + 'cart?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (s) { if (s['cart-drawer']) tegnKurvOm(s['cart-drawer']); });
  }

  function send() {
    var o = ventende;
    ventende = null;
    if (!o) return;
    // Endte hun hvor hun startede? Saa er der ikke noget at sende.
    if (o.fraVariant === o.til) return;

    /* To flag, ikke eet. window.isProcessingGift deles med motoren og med
       checkAutoGift, og motoren slukker det, naar DEN bliver faerdig med
       noget andet - ogsaa midt i vores fjern-og-tilfoej. Saa saa den en
       kurv uden gave og lagde gave nummer to i. np-gavemotor.js kigger
       derfor ogsaa paa npFarveskift, som kun vi skriver til.
       Tidsstempel og ikke bool: gaar det galt her, faar motoren lov til
       at overtage igen efter ti sekunder. Fundet live 28-09-2026. */
    window.npFarveskift = Date.now();
    window.isProcessingGift = true;

    post('cart/change.js', { id: o.lineKey, quantity: 0 })
      .then(function () {
        return post('cart/add.js', {
          items: [{
            id: o.til,
            quantity: 1,
            properties: { _is_gift: 'true', _gavetype: String(o.gavetype) }
          }],
          sections: 'cart-drawer'
        });
      })
      .then(gentegn)
      .catch(function (e) {
        console.error('[NP gave] farveskift mislykkedes:', e);
        // Kurven kan staa uden gave nu. Gentegn, saa motoren ser
        // sandheden og kan lagge den i igen.
        return gentegn(null);
      })
      .then(function () {
        window.npFarveskift = 0;
        window.isProcessingGift = false;
        document.dispatchEvent(new CustomEvent('cart:updated'));
      });
  }

  function skift(knap) {
    var raekke = knap.closest('.cart-item[data-is-gift="true"]');
    if (!raekke) return;

    var nyId = parseInt(knap.dataset.variantId, 10);
    var lineKey = raekke.dataset.lineKey;
    var gavetype = raekke.dataset.gavetype;
    if (!nyId || !lineKey || !gavetype) return;

    /* --- OEJEBLIKKELIG visning --- */
    var aktiv = raekke.querySelector('.np-gavefarve.is-active');
    var fraVariant = aktiv ? parseInt(aktiv.dataset.variantId, 10) : null;

    raekke.querySelectorAll('.np-gavefarve').forEach(function (b) {
      b.classList.remove('is-active');
      b.setAttribute('aria-pressed', 'false');
    });
    knap.classList.add('is-active');
    knap.setAttribute('aria-pressed', 'true');

    var img = raekke.querySelector('.cart-item__image');
    if (img && knap.dataset.image) {
      img.src = knap.dataset.image;
      img.loading = 'eager';
    }
    var navn = raekke.querySelector('.product-option');
    if (navn && knap.dataset.farve) navn.textContent = 'Farge: ' + knap.dataset.farve;

    /* --- Saml klikkene --- */
    if (!ventende) {
      // fraVariant er hvad SERVEREN har - altsaa farven foer foerste klik
      // i denne omgang. Laeses kun her, ikke ved hvert klik.
      ventende = { lineKey: lineKey, gavetype: gavetype, fraVariant: fraVariant };
    }
    ventende.til = nyId;

    clearTimeout(ur);
    ur = setTimeout(send, SAMLETID);
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var knap = e.target.closest('.np-gavefarve');
    if (!knap || knap.disabled || knap.classList.contains('is-active')) return;
    e.preventDefault();
    e.stopPropagation();
    skift(knap);
  });

  /* Tegner en ANDEN grund kurven om (gavemotoren, upsell'en, temaet) mens
     et klik venter, forsvinder den line key vi har samlet op. Klikket maa
     ikke bare droppes - saa ville kundens farvevalg hoppe tilbage. Vi
     sender det derfor med det samme, mens noeglen stadig gaelder. */
  document.addEventListener('cart:updated', function () {
    if (!ventende) return;
    clearTimeout(ur);
    send();
  });
})();
